export var fieldWasRegistered = function fieldWasRegistered(registeredFields, changeId, fieldId, appId) {
  var _registeredFields$app;
  return !!((_registeredFields$app = registeredFields[appId]) !== null && _registeredFields$app !== void 0 && (_registeredFields$app = _registeredFields$app[changeId]) !== null && _registeredFields$app !== void 0 && _registeredFields$app.includes(fieldId));
};